// Port of ios/Sources/ViewModels/ChannelMarkRead.swift.
//
// "Mark as read" from a conversation's row (shared/API.md §8.6.1) — clearing a conversation
// without opening it, from the same menu that mutes it. Android's `ChannelMarkRead` is the twin.

/**
 * The menu offers it only when the row is SHOWING something to clear: bold or a mention
 * badge. A muted row shows neither (user ruling 2026-10-06), so there is nothing to offer.
 */
export function isOffered(isUnread: boolean, mentionCount: number, isMuted: boolean): boolean {
  return !isMuted && (isUnread || mentionCount > 0);
}

/** Namespace form, for `ChannelMarkRead.isOffered(...)` call sites. */
export const ChannelMarkRead = { isOffered } as const;
